export const QuestionActionTypes={
    SET_FETCHED_QUESTIONS_TO_STATE_COUCH_POTATO:'SET_FETCHED_QUESTIONS_TO_STATE_COUCH_POTATO',
    SET_SELECTED_QUESTION_COUCH_POTATO:'SET_SELECTED_QUESTION_COUCH_POTATO',
    SELECTED_QUESTION_NEXT_COUCH_POTATO:'SELECTED_QUESTION_NEXT_COUCH_POTATO',
    SELECTED_QUESTION_PREVIOUS_COUCH_POTATO:'SELECTED_QUESTION_PREVIOUS_COUCH_POTATO',
    SET_SELECTED_ANSWER_COUCH_POTATO:'SET_SELECTED_ANSWER_COUCH_POTATO',
    // SET_RECENT_FETCHED_TIME:"SET_RECENT_FETCHED_TIME"
}